
<script>
import state from '@/state';
import { decompressSync, compressSync } from '@/utils';

export default {
  data: () => ({
    interval: null,
    storage: null,
    biosCustomizationId: null,

    resetEventHandler: null,
  }),

  destroyed() {
    this.bridge.removeEventListener('appDidPerformReset', this.resetEventHandler);
    this.resetEventHandler = null;
  },

  methods: {
    async reset() {
      state.clearInterval(this.interval);
      this.interval = null;

      await this.bridge.reset();

      this.$nextTick(() => {
        if (this.setupAfterReset) {
          this.setupAfterReset();
        }

        this.interval = state.setInterval(() => {
          this.handleIntervalBridgeable();
        }, 20);
      });
    },

    resetSync() {
      state.runAsync(async () => {
        await this.reset();
      });
    },

    prepareBridgeable(preInitializeCallback) {
      const storageLsKey = `${this.localStoragePrefix}Storage`;
      const storageLsValue = localStorage.getItem(storageLsKey);
      let storage;
      if (storageLsValue) {
        try {
          const compressedBuffer = Buffer.from(storageLsValue, 'base64');
          storage = decompressSync(compressedBuffer);
        } catch (err) {
          // console.log('Unable to restore state:', err);
        }
      }

      this.storage = storage;

      const { biosCustomizationId } = this;

      const options = { biosCustomizationId, preInitializeCallback };
      this.bridge.initialize((defaultOptions) => {
        return {
          ...defaultOptions,
          ...options,
          storage: this.storage,
        };
      });

      this.resetEventHandler = async () => {
        await this.reset();
      };
      this.bridge.on('appDidPerformReset', this.resetEventHandler);

      this.$nextTick(() => {
        this.preparePlatform();

        this.interval = state.setInterval(() => {
          this.handleIntervalBridgeable();
        }, 20);
      });
    },

    handleIntervalBridgeable() {
      if (this.bridge.isStorageInvalidated()) {
        const buffer = this.bridge.exportStorage();

        this.storage = buffer;

        const compressedBuffer = compressSync(buffer);

        const storageLsKey = `${this.localStoragePrefix}Storage`;
        localStorage.setItem(storageLsKey, compressedBuffer.toString('base64'));
      }
      this.handleInterval();
    },

    destroyed() {
      // console.log('destroyed');

      state.clearInterval(this.interval);
      this.interval = null;
      this.bridge.stop();
    },
  },
};
</script>
